import React from 'react';

function Error404() {
  return (
    <div className="text-center m-auto text-3xl font-bold">
      <h1>Error 404</h1>
      <p className="text-xl">Page not found!</p>
    </div>
  );
}

export default Error404;
